import { Component, OnInit } from "@angular/core";
import { WebappService } from "../../../service/webapp.service";
import { ActivatedRoute, Router } from "@angular/router";
import { isDefined } from "@angular/compiler/src/util";
import { environment } from ".././../../../environments/environment";

@Component({
  selector: "app-your-rides",
  templateUrl: "./your-rides.component.html",
  styleUrls: ["./your-rides.component.scss"]
})
export class YourRidesComponent implements OnInit {
  profileid: any;
  profilelog: any;
  pastRides: any;
  onGoingRides: any;
  onGoingRideStatus: any;
  pastRideStatus: any;
  ad_unit_id:any;
  admin_enable_ads:any;
  loadhistory: boolean = false;
  url: any;
  red_url: any;
  currencySymbol: any = "$";
  constructor(private apiservice: WebappService, private router: Router) {
    this.onGoingRideStatus = false;
    this.pastRideStatus = false;
  }

  ngOnInit() {
    if (localStorage.getItem("CS")) {
      this.currencySymbol = localStorage.getItem("CS");
    }
    this.url = environment.apiUrl;
    this.profilelog = JSON.parse(localStorage.getItem("user"));
    this.profileid = this.profilelog.id;
    this.ad_unit_id = this.profilelog.ad_unit_id;
    this.admin_enable_ads=this.profilelog.admin_enable_ads;
    const pastrideData = {
      user_id: this.profileid,
      type: "history"
    };

    const presentrideData = {
      user_id: this.profileid,
      type: "booking"
    };

    this.apiservice.ridehistory(pastrideData).subscribe(data => {
      if (data["status"] === "true") {
        if (isDefined(data["result"])) {
          this.pastRides = data["result"];
          this.pastRideStatus = true;
        }
      }
      /* console.log("RideStatus" + this.pastRideStatus); */
    });

    this.apiservice.ridehistory(presentrideData).subscribe(data => {
      if (data["status"] === "true") {
        if (isDefined(data["result"])) {
          this.onGoingRideStatus = true;
          this.onGoingRides = data["result"];
        }
      }
      /* console.log("RideStatus" + this.onGoingRideStatus); */
    });
  }

  activeRide(rideId) {
    this.router.navigate(["/active-rides", btoa(rideId)]);
  }

  inactiveRide(rideId) {
    this.router.navigate(["/inactive-rides", btoa(rideId)]);
  }

  completedRide(rideId) {
    this.router.navigate(["/completed-rides", btoa(rideId)]);
  }
}
